import { cdataFetch } from "../../../api/cdataFetch";
import { IScheduledQueryList } from "../../../models/ScheduledQueries/IScheduledQueryList";

export async function listScheduledQueries() {
  return cdataFetch<IScheduledQueryList>({
    method: "GET",
    url: `/scheduledquery/list`,
  });
}
